import RegistrationStatusTag from './RegistrationStatusTag';
import { RegistrationStatusTagProps, RegistrationStatusTagValueProps } from './types';

export type { RegistrationStatusTagProps, RegistrationStatusTagValueProps };
export default RegistrationStatusTag;
